import { gql, useMutation } from '@apollo/client';

import { GET_HOLIDAY_LOCATIONS_BY_COMPANY } from './get-holiday-locations-by-company.hook';

export const DELETE_HOLIDAY_LOCATION = gql`
  mutation deleteHolidayLocationById($holidayLocationId: String!) {
    deleteHolidayLocationById(holidayLocationId: $holidayLocationId)
  }
`;

export const useDeleteHolidayLocation = () => {
  const [deleteHolidayLocation] = useMutation(DELETE_HOLIDAY_LOCATION, {
    refetchQueries: [GET_HOLIDAY_LOCATIONS_BY_COMPANY],
  });

  return deleteHolidayLocation;
};
